import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Flex, Box } from '@rebass/grid';
import ReactGA from 'react-ga';
import { isMobile } from 'app/helpers/utils';
import animate from 'app/helpers/animations/searchForm';

import WithTitle from 'app/layouts/WithTitle';
import { domainIsValid, emailIsValid } from 'app/helpers/validators';
import { Button, Input, P } from 'app/ui_components/tags';
import BackgroundImages from 'app/ui_components/BackgroundImages';
import { EMPLOYEE_CUSTOMER, EMPLOYEE } from 'app/helpers/constants';
import { onInputChange, search } from 'app/redux/actions';
import UsfUnlockForm from 'app/components/UsfUnlockForm';

class SearchForm extends React.Component {
  static propTypes = {
    layout: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    domain: PropTypes.string.isRequired,
    userType: PropTypes.string.isRequired,
    disabled: PropTypes.bool.isRequired,
    search: PropTypes.func.isRequired,
    usFoods: PropTypes.bool.isRequired
  };

  static defaultProps = {
    userType: '',
    usFoods: false,
    disabled: false
  }

  componentWillUnmount() {
    animate();
  }

  render() {
    const {
      props: { usFoods, userType, layout, onChange, domain, disabled, search },
      messages,
    } = this;

    const showUsFoodForm = usFoods && userType && userType !== EMPLOYEE; // show  usFood form
    return (
      <React.Fragment>
        <WithTitle
          id="searchForm"
          childrenInheritLayout
          title="Find out what's missing from your restaurant's website"
          subtitle="The only website grader built and optimized for the hospitality industry. Enter your URL below to get started."
          mb={38}
          mt={showUsFoodForm && userType === EMPLOYEE_CUSTOMER ? 50 : 200}
        >
          <Flex
            alignItems="center"
            justifyContent="center"
            flexDirection="column"
          >
            {showUsFoodForm && <Box {...layout} mb="24px" px={isMobile ? 0 : 'inherit'}>
              <UsfUnlockForm />
            </Box>}

            <Box {...layout} mb="24px" px={isMobile ? 0 : ['30px', '0px', '0px']}>
              <Input
                name="domain"
                type="text"
                onChange={onChange}
                value={domain}
                placeholder="www.myrestaurantwebsite.com"
                id="domainInput"
                aria-label="The restaurant website you would like to search"
                border
              />
            </Box>
            <Box {...layout} px={isMobile ? 0 : ['30px', '0px', '0px']}>
              <Button
                onClick={search}
                disabled={disabled}
                id="submitButton"
                type="submit"
              >
                Reveal Results
              </Button>
            </Box>
          </Flex>
        </WithTitle>
        <BackgroundImages />
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({
  usFoods,
  website: { domain },
  step,
  user: { userType, email, restaurantName } }) => {
  const usFoodDisabled = usFoods && userType === EMPLOYEE_CUSTOMER && (email.length === 0 || restaurantName.length === 0 || !emailIsValid(email));

  return {
    usFoods,
    userType,
    domain,
    disabled: domain.length === 0 || !domainIsValid(domain) || usFoodDisabled
  };
};

const mapDispatchToProps = dispatch => ({
  search: async e => {
    ReactGA.event({
      category: 'Landing Page',
      action: 'Click',
      label: 'url-submit',
    });
    dispatch(search());
  },
  onChange: e =>
    dispatch(
      onInputChange('website', 'domain', e.target.value, value => value.trim())
    )
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchForm);
